import React, { useState } from 'react';
import '../Assests/RegisterEmp.css';
import { addprofile } from '../Db_Connections/Profile_API'; // Path sahi kar lena jahan api.js banaya hai

const employmentTypes = ['Full-time', 'Part-time', 'Intern', 'Contract'];
const roles = ['Employee', 'Manager', 'HR', 'Admin'];

export default function RegisterEmployee({ onBack, onSubmit }) {
  const [loading, setLoading] = useState(false); // Loading state add kiya
  const [form, setForm] = useState({
    employeeId: '',
    firstName: '',
    lastName: '',
    officialEmail: '',
    personalEmail: '',
    phone: '',
    dob: '',
    gender: '',
    designation: '',
    department: '',
    employmentType: '',
    joiningDate: '',
    location: '',
    managerName: '',
    role: '',
    tempPassword: '',
    notes: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!form.officialEmail.trim()) newErrors.officialEmail = 'Official email is required';
    if (!form.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!form.designation.trim()) newErrors.designation = 'Designation is required';
    if (!form.department.trim()) newErrors.department = 'Department is required';
    if (!form.employmentType) newErrors.employmentType = 'Employment type is required';
    if (!form.joiningDate) newErrors.joiningDate = 'Joining date is required';
    if (!form.role) newErrors.role = 'Role is required';
    
    // Email regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.officialEmail && !emailRegex.test(form.officialEmail)) {
      newErrors.officialEmail = 'Enter a valid email address';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true); // Button disable karne ke liye

    // API Call
    const { data, error } = await addprofile(form);

    setLoading(false);

    if (error) {
      console.error(error);
      alert('Error saving data: ' + error.message);
    } else {
      alert('Data Saved Successfully!'); // Success message
      
      // Parent ko data bhejo
      onSubmit?.(data);

      // Form Reset
      setForm({
        employeeId: '',
        firstName: '',
        lastName: '',
        officialEmail: '',
        personalEmail: '',
        phone: '',
        dob: '',
        gender: '',
        designation: '',
        department: '',
        employmentType: '',
        joiningDate: '',
        location: '',
        managerName: '',
        role: '',
        tempPassword: '',
        notes: '',
      });
    }
  };

  return (
    <div className="register-page">
      <div className="register-header">
        <div>
          <h1 className="register-title">Register New Employee</h1>
          <p className="register-subtitle">Add a new member to your organization</p>
        </div>
        {onBack && (
          <button className="register-back-btn" onClick={onBack}>← Back</button>
        )}
      </div>

      <form className="register-card" onSubmit={handleSubmit} noValidate>
        <div className="register-grid">
          {/* Employee ID (Optional in DB but required in Form) */}
          <div className="form-group">
            <label className="form-label">Employee ID</label>
            <input
              type="text"
              name="employeeId"
              value={form.employeeId}
              onChange={handleChange}
              className="form-input"
              placeholder="EMP-001"
            />
          </div>

          <div className="form-group">
            <label className="form-label">First Name <span className="req">*</span></label>
            <input type="text" name="firstName" value={form.firstName} onChange={handleChange} className={`form-input ${errors.firstName ? 'has-error' : ''}`} />
            {errors.firstName && <p className="error-text">{errors.firstName}</p>}
          </div>

          <div className="form-group">
            <label className="form-label">Last Name</label>
            <input type="text" name="lastName" value={form.lastName} onChange={handleChange} className="form-input" />
          </div>

          <div className="form-group">
            <label className="form-label">Official Email <span className="req">*</span></label>
            <input type="email" name="officialEmail" value={form.officialEmail} onChange={handleChange} className={`form-input ${errors.officialEmail ? 'has-error' : ''}`} />
            {errors.officialEmail && <p className="error-text">{errors.officialEmail}</p>}
          </div>

          <div className="form-group">
            <label className="form-label">Phone <span className="req">*</span></label>
            <input type="tel" name="phone" value={form.phone} onChange={handleChange} className={`form-input ${errors.phone ? 'has-error' : ''}`} />
            {errors.phone && <p className="error-text">{errors.phone}</p>}
          </div>
          
          {/* Personal Email */}
          <div className="form-group">
            <label className="form-label">Personal Email</label>
            <input type="email" name="personalEmail" value={form.personalEmail} onChange={handleChange} className="form-input" />
          </div>

          {/* DOB */}
          <div className="form-group">
            <label className="form-label">Date of Birth</label>
            <input type="date" name="dob" value={form.dob} onChange={handleChange} className="form-input" />
          </div>

           {/* Gender */}
           <div className="form-group">
            <label className="form-label">Gender</label>
            <select name="gender" value={form.gender} onChange={handleChange} className="form-input">
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Designation */}
          <div className="form-group">
            <label className="form-label">Designation <span className="req">*</span></label>
            <input type="text" name="designation" value={form.designation} onChange={handleChange} className={`form-input ${errors.designation ? 'has-error' : ''}`} />
             {errors.designation && <p className="error-text">{errors.designation}</p>}
          </div>

          {/* Department */}
          <div className="form-group">
            <label className="form-label">Department <span className="req">*</span></label>
            <input type="text" name="department" value={form.department} onChange={handleChange} className={`form-input ${errors.department ? 'has-error' : ''}`} />
             {errors.department && <p className="error-text">{errors.department}</p>}
          </div>

          {/* Employment Type */}
          <div className="form-group">
            <label className="form-label">Employment Type <span className="req">*</span></label>
            <select name="employmentType" value={form.employmentType} onChange={handleChange} className={`form-input ${errors.employmentType ? 'has-error' : ''}`}>
              <option value="">Select type</option>
              {employmentTypes.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
             {errors.employmentType && <p className="error-text">{errors.employmentType}</p>}
          </div>

          {/* Joining Date */}
          <div className="form-group">
            <label className="form-label">Joining Date <span className="req">*</span></label>
            <input type="date" name="joiningDate" value={form.joiningDate} onChange={handleChange} className={`form-input ${errors.joiningDate ? 'has-error' : ''}`} />
             {errors.joiningDate && <p className="error-text">{errors.joiningDate}</p>}
          </div>

           {/* Location */}
           <div className="form-group">
            <label className="form-label">Location</label>
            <input type="text" name="location" value={form.location} onChange={handleChange} className="form-input" />
          </div>

           {/* Manager */}
           <div className="form-group">
            <label className="form-label">Reporting Manager</label>
            <input type="text" name="managerName" value={form.managerName} onChange={handleChange} className="form-input" />
          </div>

          {/* Role */}
          <div className="form-group">
            <label className="form-label">Role <span className="req">*</span></label>
            <select name="role" value={form.role} onChange={handleChange} className={`form-input ${errors.role ? 'has-error' : ''}`}>
              <option value="">Select role</option>
              {roles.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
            {errors.role && <p className="error-text">{errors.role}</p>}
          </div>

          {/* Temp Password */}
          <div className="form-group">
            <label className="form-label">Temp Password (Login)</label>
            <input type="text" name="tempPassword" value={form.tempPassword} onChange={handleChange} className="form-input" placeholder="Set password for user" />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Notes</label>
          <textarea name="notes" value={form.notes} onChange={handleChange} className="form-input form-textarea" />
        </div>

        <div className="register-footer">
          {onBack && <button type="button" className="btn-secondary" onClick={onBack}>Cancel</button>}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Saving...' : 'Save Employee'}
          </button>
        </div>
      </form>
    </div>
  );
}